export default "__VITE_ASSET__BOTSOLj1__"